export default "__VITE_ASSET__CAq2t4Gp__"